"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var SubHeading_1 = __importDefault(require("./SubHeading"));
var SummaryRow_1 = __importDefault(require("./SummaryRow"));
var PricingEstimateSummary = function (_a) {
    var total = _a.total, totalAddOns = _a.totalAddOns, totalOneTimeFees = _a.totalOneTimeFees;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ py: 4, width: 1370 }, { children: [(0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {}), (0, jsx_runtime_1.jsx)(SubHeading_1.default, { title: "Pricing Estimate Summary" }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ my: 1 }, { children: [(0, jsx_runtime_1.jsx)(SummaryRow_1.default, { name: "Monthly cost:", subTotal: total + totalAddOns, frequency: "/mo" }), (0, jsx_runtime_1.jsx)(SummaryRow_1.default, { name: "Plan subtotal:", subTotal: (total + totalAddOns) * 12, frequency: "/yr" }), (0, jsx_runtime_1.jsx)(SummaryRow_1.default, { name: "Estimated cost to get started:", subTotal: total + totalAddOns + totalOneTimeFees })] }))] })));
};
exports.default = PricingEstimateSummary;
